import { SET } from "vuelpers/lib/vuex"
import { UsersAPI } from "../../firebase/api.firebase"
import { createGetters, createMutations } from "vuelpers"

const initialState = () => ({
	users: [],
	isUpdate: false,
	user: { id: null },
	isSubscribed: false,
})

const state = initialState()
const mutations = createMutations(SET)
const getters = createGetters("users", 'user', 'isUpdate')

const actions = {
	subscribeUsers({ commit, state }) {
		if (state.isSubscribed) return
		commit(SET, { isSubscribed: true })
		UsersAPI.onSnapshot(([error, users]) => {
			!error && commit(SET, { users })
		})
	},
	resetState({ commit }) {
		commit(SET, initialState())
	}
}

export default {
	state,
	actions,
	getters,
	mutations,
	namespaced: true
}
